module.exports = __webpack_public_path__ + "static/img/logo-img-new.6d5b7243.png";